'use client';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import type { ReactNode } from 'react';

type GoogleRecaptchaPageShellProps = {
    readonly children: ReactNode;
};

/**
 * Wraps pages that call `useGoogleReCaptcha` (login, password reset).
 * Kept off the shared full-page layout so authenticated flows (e.g. CSV import footer)
 * are not covered by the reCAPTCHA badge iframe.
 */
export const GoogleRecaptchaPageShell = ({ children }: GoogleRecaptchaPageShellProps) => {
    const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;

    if (!siteKey) {
        return children;
    }

    return <GoogleReCaptchaProvider reCaptchaKey={siteKey}>{children}</GoogleReCaptchaProvider>;
};

GoogleRecaptchaPageShell.displayName = 'GoogleRecaptchaPageShell';
